<template>
  <div>

    <div id="sideMenuBox" wrap-class="scrollbar-wrapper">
      <a-menu
      :open-keys="openKeys"
        v-model:selectedKeys="activeMenu"
        :inline-collapsed="isCollapse"
        theme="light"
        mode="inline"
        @openChange="onOpenChange"
      >
        <sidebar-item
          v-for="(route) in sidebarRouters"
          :key="route.path "
          :item="route"
          :base-path="route.path"
        />
      </a-menu>
    </div>

    <div
      style="padding: 0 15px"
      id="hamburger-container"
      class="hamburger-container"
      @click="toggleSideBar"
    >
      <svg
        :class="{ 'is-active': appStore.sidebar.opened }"
        class="hamburger"
        viewBox="0 0 1024 1024"
        xmlns="http://www.w3.org/2000/svg"
        width="64"
        height="64"
      >
        <path
          d="M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM142.4 642.1L298.7 519a8.84 8.84 0 0 0 0-13.9L142.4 381.9c-5.8-4.6-14.4-.5-14.4 6.9v246.3a8.9 8.9 0 0 0 14.4 7z"
        />
      </svg>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, watch } from "vue";
import { useRoute } from "vue-router";
import SidebarItem from "./SidebarItem";
import useAppStore from "@/store/modules/app";
import useSettingsStore from "@/store/modules/settings";
import usePermissionStore from "@/store/modules/permission";

const route = useRoute();
const appStore = useAppStore();
const settingsStore = useSettingsStore();
const permissionStore = usePermissionStore();

const sidebarRouters = computed(() => permissionStore.sidebarRouters);
const isCollapse = computed(() => !appStore.sidebar.opened);

const activeMenu = computed(() => {
  const { meta, path } = route;
  // if set path, the sidebar will highlight the path you set
  if (meta.activeMenu) {
    return [meta.activeMenu];
  }
  return [path];
});
let my_openKeys=ref([])

const openKeys = computed(() => {
  const { matched,path } = route;
  const keys =[]
  let arr=[];
  arr=path.split('/');
  arr.shift(1);
  arr.map((item,i)=>{
    if(i==0){
      keys.push('/'+item)
    }else{
      keys.push(item)
    }
  })
  return isCollapse.value==true?[]:keys;
});

watch(()=>route,val=>{
  const { matched,path } = route;
  // const keys = matched.map((item) => item.path);
  const keys =[]
  console.log(path)
  let arr=[];
  arr=path.split('/');
  arr.shift(1);
  arr.map((item,i)=>{
    keys.push('/'+item)
  })
  console.log(keys)
  return isCollapse.value==true?[]:keys

})


function toggleSideBar() {
  appStore.toggleSideBar()
}
</script>


<style lang="less" scoped>
.scrollbar-wrapper {
  overflow-x: hidden !important;
}
#sideMenuBox{
  height: calc( 100%  - 50px );
  overflow-y: auto;
  overflow-x: hidden;
}
.hamburger-container {
  svg {
    display: inline-block;
    vertical-align: middle;
    width: 20px;
    height: 20px;
  }
  line-height: 46px;
  height: 100%;
  float: left;
  cursor: pointer;
  transition: background 0.3s;
  -webkit-tap-highlight-color: transparent;

  &:hover {
    background: rgba(0, 0, 0, 0.025);
  }
}
/deep/.ant-menu-light{

  .ant-menu-item{
    height: 48px;
    line-height: 48px;
    border-radius: 0;
    margin: 0;
    width: 100%;
   
    .ant-menu-title-content{
      height: 48px;
    }
  }

  .ant-menu-submenu-title{
    margin: 0px 0;
    width: 100%;
    border-radius: 0;
    height: 48px!important;
    line-height: 48px!important;
    
   
  }

  .ant-menu-submenu{
    .ant-menu-submenu{
      .ant-menu-submenu-title{
        background: rgba(249, 249, 249, 1);
      }
      .ant-menu-item {
        background: rgba(225, 234, 241, 1);
      }
    }
  }

  .ant-menu-title-content{
    .anticon {
      transition:none;
      &+span{
        transition:none;
      }
    }
    a{
      transition:none!important;
    }
  }
  .ant-menu-item-only-child{
    // margin-inline: 4px!important;
  }
.ant-menu-item-selected{
    background-color:rgba(19, 97, 171, 0.80)!important;
    color:#fff;
    position: relative;
    &::after{
      content: "";
      display: inline-block;
      width: 6px;
      height: 100%;
      background: #1E8EF2;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
  .ant-menu-submenu-selected{
    .ant-menu-submenu-title{
      color:inherit!important;
    }
  }
} 
/deep/.ant-menu-submenu-arrow{
    color: rgba(10, 33, 46, 1);
  }
</style>